'use strict'
import ModulAPI from '../../api/modul'

const CREATE_MODUL = 'CREATE_MODUL',
    CREATE_MODUL_SUCCESS = 'CREATE_MODUL_SUCCESS',
    CREATE_MODUL_ERROR = 'CREATE_MODUL_ERROR',
    FETCHING_MODULE = 'FETCHING_MODULE',
    FETCHING_MODULE_SUCCESS = 'FETCHING_MODULE_SUCCESS',
    FETCHING_MODULE_ERROR = 'FETCHING_MODULE_ERROR',
    SAVE_MODULVERANTWORTLICHER = 'SAVE_MODULVERANTWORTLICHER',
    SAVE_MODULVERANTWORTLICHER_SUCCESS = 'SAVE_MODULVERANTWORTLICHER_SUCCESS',
    SAVE_MODULVERANTWORTLICHER_ERROR = 'SAVE_MODULVERANTWORTLICHER_ERROR',
    SAVE_LEHRENDE = 'SAVE_LEHRENDE',
    SAVE_LEHRENDE_SUCCESS = 'SAVE_LEHRENDE_SUCCESS',
    SAVE_LEHRENDE_ERROR = 'SAVE_LEHRENDE_ERROR',
    SAVE_VERANSTALTUNGSORT = 'SAVE_VERANSTALTUNGSORT',
    SAVE_VERANSTALTUNGSORT_SUCCESS = 'SAVE_VERANSTALTUNGSORT_SUCCESS',
    SAVE_VERANSTALTUNGSORT_ERROR = 'SAVE_VERANSTALTUNGSORT_ERROR',
    SAVE_BENOTUNG = 'SAVE_BENOTUNG',
    SAVE_BENOTUNG_SUCCESS = 'SAVE_BENOTUNG_SUCCESS',
    SAVE_BENOTUNG_ERROR = 'SAVE_BENOTUNG_ERROR',
    SAVE_ZWINGENDE_VORAUSSETZUNGEN = 'SAVE_ZWINGENDE_VORAUSSETZUNGEN',
    SAVE_ZWINGENDE_VORAUSSETZUNGEN_SUCCESS = 'SAVE_ZWINGENDE_VORAUSSETZUNGEN_SUCCESS',
    SAVE_ZWINGENDE_VORAUSSETZUNGEN_ERROR = 'SAVE_ZWINGENDE_VORAUSSETZUNGEN_ERROR',
    SAVE_EMPFOHLENE_VORAUSSETZUNGEN = 'SAVE_EMPFOHLENE_VORAUSSETZUNGEN',
    SAVE_EMPFOHLENE_VORAUSSETZUNGEN_SUCCESS = 'SAVE_EMPFOHLENE_VORAUSSETZUNGEN_SUCCESS',
    SAVE_EMPFOHLENE_VORAUSSETZUNGEN_ERROR = 'SAVE_EMPFOHLENE_VORAUSSETZUNGEN_ERROR',
    SAVE_LERNZIELE = 'SAVE_LERNZIELE',
    SAVE_LERNZIELE_SUCCESS = 'SAVE_LERNZIELE_SUCCESS',
    SAVE_LERNZIELE_ERROR = 'SAVE_LERNZIELE_ERROR',
    SAVE_ANGEBOTSFREQUENZ = 'SAVE_ANGEBOTSFREQUENZ',
    SAVE_ANGEBOTSFREQUENZ_SUCCESS = 'SAVE_ANGEBOTSFREQUENZ_SUCCESS',
    SAVE_ANGEBOTSFREQUENZ_ERROR = 'SAVE_ANGEBOTSFREQUENZ_ERROR',
    SAVE_MODULINHALTE = 'SAVE_MODULINHALTE',
    SAVE_MODULINHALTE_SUCCESS = 'SAVE_MODULINHALTE_SUCCESS',
    SAVE_MODULINHALTE_ERROR = 'SAVE_MODULINHALTE_ERROR',
    SAVE_VORAUSSETZUNG_PRUEFUNG = 'SAVE_VORAUSSETZUNG_PRUEFUNG',
    SAVE_VORAUSSETZUNG_PRUEFUNG_SUCCESS = 'SAVE_VORAUSSETZUNG_PRUEFUNG_SUCCESS',
    SAVE_VORAUSSETZUNG_PRUEFUNG_ERROR = 'SAVE_VORAUSSETZUNG_PRUEFUNG_ERROR',
    SAVE_VORAUSSETZUNG_ECTS = 'SAVE_VORAUSSETZUNG_ECTS',
    SAVE_VORAUSSETZUNG_ECTS_SUCCESS = 'SAVE_VORAUSSETZUNG_ECTS_SUCCESS',
    SAVE_VORAUSSETZUNG_ECTS_ERROR = 'SAVE_VORAUSSETZUNG_ECTS_ERROR',
    SAVE_MEDIENFORM = 'SAVE_MEDIENFORM',
    SAVE_MEDIENFORM_SUCCESS = 'SAVE_MEDIENFORM_SUCCESS',
    SAVE_MEDIENFORM_ERROR = 'SAVE_MEDIENFORM_ERROR',
    SAVE_DOKUMENTLINKS = 'SAVE_DOKUMENTLINKS',
    SAVE_DOKUMENTLINKS_SUCCESS = 'SAVE_DOKUMENTLINKS_SUCCESS',
    SAVE_DOKUMENTLINKS_ERROR = 'SAVE_DOKUMENTLINKS_ERROR',
    SAVE_LITERATUR = 'SAVE_LITERATUR',
    SAVE_LITERATUR_SUCCESS = 'SAVE_LITERATUR_SUCCESS',
    SAVE_LITERATUR_ERROR = 'SAVE_LITERATUR_ERROR',
    SAVE_GEFOERDERTE_KOMPETENZEN = 'SAVE_GEFOERDERTE_KOMPETENZEN',
    SAVE_GEFOERDERTE_KOMPETENZEN_SUCCESS = 'SAVE_GEFOERDERTE_KOMPETENZEN_SUCCESS',
    SAVE_GEFOERDERTE_KOMPETENZEN_ERROR = 'SAVE_GEFOERDERTE_KOMPETENZEN_ERROR',
    SAVE_MODULSTRUKTUR = 'SAVE_MODULSTRUKTUR',
    SAVE_MODULSTRUKTUR_SUCCESS = 'SAVE_MODULSTRUKTUR_SUCCESS',
    SAVE_MODULSTRUKTUR_ERROR = 'SAVE_MODULSTRUKTUR_ERROR'
const replaceObjectInStateArray = (state, newModul) => {
    state.module = [...state.module.filter((modul) => modul.modulId !== newModul.modulId), newModul]
}

export default {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
        module: []
    },
    getters: {
        getModulById(state) {
            return (modulId) => state.module.find((modul) => modul.modulId === modulId)
        },
        getModulByIri(state) {
            return (modulIri) => state.module.find((modul) => modul['@id'] === modulIri)
        },
        module(state) {
            return state.module
        },
        isLoading(state) {
            return state.isLoading
        },
        hasError(state) {
            return state.error !== null
        },
        error(state) {
            return state.error
        },
        hasModule(state) {
            return state.module.length > 0
        }
    },
    mutations: {
        [CREATE_MODUL](state) {
            state.isLoading = true
            state.error = null
        },
        [CREATE_MODUL_SUCCESS](state) {
            state.isLoading = false
            state.error = null
            // add passed modul to state.module
        },
        [CREATE_MODUL_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [FETCHING_MODULE](state) {
            state.isLoading = true
            state.error = null
            state.module = []
        },
        [FETCHING_MODULE_SUCCESS](state, module) {
            state.isLoading = false
            state.error = null
            state.module = module.sort((obj1, obj2) => (obj1.kurzName < obj2.kurzName ? -1 : 1))
        },
        [FETCHING_MODULE_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_MODULVERANTWORTLICHER](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_MODULVERANTWORTLICHER_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_MODULVERANTWORTLICHER_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_LEHRENDE](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_LEHRENDE_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_LEHRENDE_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_VERANSTALTUNGSORT](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_VERANSTALTUNGSORT_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_VERANSTALTUNGSORT_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_BENOTUNG](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_BENOTUNG_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_BENOTUNG_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_ZWINGENDE_VORAUSSETZUNGEN](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_ZWINGENDE_VORAUSSETZUNGEN_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_ZWINGENDE_VORAUSSETZUNGEN_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_EMPFOHLENE_VORAUSSETZUNGEN](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_EMPFOHLENE_VORAUSSETZUNGEN_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_EMPFOHLENE_VORAUSSETZUNGEN_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_LERNZIELE](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_LERNZIELE_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_LERNZIELE_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_ANGEBOTSFREQUENZ](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_ANGEBOTSFREQUENZ_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_ANGEBOTSFREQUENZ_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_MODULINHALTE](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_MODULINHALTE_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_MODULINHALTE_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_VORAUSSETZUNG_PRUEFUNG](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_VORAUSSETZUNG_PRUEFUNG_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_VORAUSSETZUNG_PRUEFUNG_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_VORAUSSETZUNG_ECTS](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_VORAUSSETZUNG_ECTS_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_VORAUSSETZUNG_ECTS_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_MEDIENFORM](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_MEDIENFORM_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_MEDIENFORM_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_DOKUMENTLINKS](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_DOKUMENTLINKS_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_DOKUMENTLINKS_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_LITERATUR](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_LITERATUR_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_LITERATUR_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_GEFOERDERTE_KOMPETENZEN](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_GEFOERDERTE_KOMPETENZEN_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_GEFOERDERTE_KOMPETENZEN_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [SAVE_MODULSTRUKTUR](state) {
            state.isLoading = true
            state.error = null
        },
        [SAVE_MODULSTRUKTUR_SUCCESS](state, newModule) {
            state.isLoading = false
            state.error = null
            replaceObjectInStateArray(state, newModule)
        },
        [SAVE_MODULSTRUKTUR_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        }
    },
    actions: {
        async findAll({ commit }) {
            commit(FETCHING_MODULE)
            try {
                let response = await ModulAPI.findAll()
                commit(FETCHING_MODULE_SUCCESS, response.data['hydra:member'])
                return response.data['hydra:member']
            } catch (error) {
                commit(FETCHING_MODULE_ERROR, error)
                return null
            }
        },
        async saveModulVerantwortlicher({ commit }, { modulId, modulverantwortlicher }) {
            commit(SAVE_MODULVERANTWORTLICHER)
            try {
                let response = await ModulAPI.saveModulVerantwortliche(
                    modulId,
                    modulverantwortlicher
                )
                commit(SAVE_MODULVERANTWORTLICHER_SUCCESS, response.data)
                // const modulToEdit = state.module.find(modul => modul.modulId === modulId);
                // const newModule = {...modulToEdit, modulverantwortliche: modulverantwortlicher};
                // commit(SAVE_MODULVERANTWORTLICHER_SUCCESS, newModule);
            } catch (error) {
                commit(SAVE_MODULVERANTWORTLICHER_ERROR, error)
                return null
            }
        },
        async saveLehrende({ commit }, { modulId, lehrendeIds }) {
            commit(SAVE_LEHRENDE)
            try {
                let response = await ModulAPI.saveLehrende(modulId, lehrendeIds)
                commit(SAVE_LEHRENDE_SUCCESS, response.data)
                // const modulToEdit = state.module.find(modul => modul.modulId === modulId);
                // const newModule = {...modulToEdit, 'lehrende': lehrendeIds};
                // commit(SAVE_LEHRENDE_SUCCESS, newModule);
            } catch (error) {
                commit(SAVE_LEHRENDE_ERROR, error)
                return null
            }
        },
        async saveVeranstaltungsOrt({ commit, state }, { modulId, newOrt }) {
            commit(SAVE_VERANSTALTUNGSORT)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, veranstaltungsOrt: newOrt }
                commit(SAVE_VERANSTALTUNGSORT_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_VERANSTALTUNGSORT_ERROR, error)
                return null
            }
        },
        async saveBenotung({ commit, state }, { modulId, newBenotung }) {
            commit(SAVE_BENOTUNG)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, benotung: newBenotung }
                commit(SAVE_BENOTUNG_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_BENOTUNG_ERROR, error)
                return null
            }
        },
        async saveZwingendeVoraussetzungen({ commit, state }, { modulId, newVoraussetzungen }) {
            commit(SAVE_ZWINGENDE_VORAUSSETZUNGEN)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, zwingendeVoraussetzungen: newVoraussetzungen }
                commit(SAVE_ZWINGENDE_VORAUSSETZUNGEN_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_ZWINGENDE_VORAUSSETZUNGEN_ERROR, error)
                return null
            }
        },
        async saveEmpfohleneVoraussetzungen({ commit, state }, { modulId, newVoraussetzungen }) {
            commit(SAVE_EMPFOHLENE_VORAUSSETZUNGEN)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, empfohleneVoraussetzungen: newVoraussetzungen }
                commit(SAVE_EMPFOHLENE_VORAUSSETZUNGEN_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_EMPFOHLENE_VORAUSSETZUNGEN_ERROR, error)
                return null
            }
        },
        async saveLernziele({ commit, state }, { modulId, newLernziele }) {
            commit(SAVE_LERNZIELE)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, lernziele: newLernziele }
                commit(SAVE_LERNZIELE_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_LERNZIELE_ERROR, error)
                return null
            }
        },
        async saveAngebotsfrequenz({ commit, state }, { modulId, newValue }) {
            commit(SAVE_ANGEBOTSFREQUENZ)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, angebotsfrequenz: newValue }
                commit(SAVE_ANGEBOTSFREQUENZ_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_ANGEBOTSFREQUENZ_ERROR, error)
                return null
            }
        },
        async saveModulInhalte({ commit, state }, { modulId, newValue }) {
            commit(SAVE_MODULINHALTE)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, inhalte: newValue }
                commit(SAVE_MODULINHALTE_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_MODULINHALTE_ERROR, error)
                return null
            }
        },
        async saveVoraussetzungPruefung({ commit, state }, { modulId, newValue }) {
            commit(SAVE_VORAUSSETZUNG_PRUEFUNG)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, voraussetzungPruefungsZulassung: newValue }
                commit(SAVE_VORAUSSETZUNG_PRUEFUNG_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_VORAUSSETZUNG_PRUEFUNG_ERROR, error)
                return null
            }
        },
        async saveVoraussetzungEcts({ commit, state }, { modulId, newValue }) {
            commit(SAVE_VORAUSSETZUNG_ECTS)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, voraussetzungenVergabeEcts: newValue }
                commit(SAVE_VORAUSSETZUNG_ECTS_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_VORAUSSETZUNG_ECTS_ERROR, error)
                return null
            }
        },
        async saveMedienform({ commit, state }, { modulId, newValue }) {
            commit(SAVE_MEDIENFORM)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, medienformen: newValue }
                commit(SAVE_MEDIENFORM_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_MEDIENFORM_ERROR, error)
                return null
            }
        },
        async saveDokumentLinks({ commit, state }, { modulId, newValue }) {
            commit(SAVE_DOKUMENTLINKS)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, dokumentLinks: newValue }
                commit(SAVE_DOKUMENTLINKS_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_DOKUMENTLINKS_ERROR, error)
                return null
            }
        },
        async saveLiteratur({ commit, state }, { modulId, newValue }) {
            commit(SAVE_LITERATUR)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, literatur: newValue }
                commit(SAVE_LITERATUR_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_LITERATUR_ERROR, error)
                return null
            }
        },
        async saveGefoerderteKompetenzen({ commit, state }, { modulId, newValue }) {
            commit(SAVE_GEFOERDERTE_KOMPETENZEN)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, gefoerderteKompetenzen: newValue }
                commit(SAVE_GEFOERDERTE_KOMPETENZEN_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_GEFOERDERTE_KOMPETENZEN_ERROR, error)
                return null
            }
        },
        async saveModulStruktur({ commit, state }, { modulId, newValue }) {
            commit(SAVE_MODULSTRUKTUR)
            try {
                const modulToEdit = state.module.find((modul) => modul.modulId === modulId)
                const newModule = { ...modulToEdit, modulStruktur: newValue }
                commit(SAVE_MODULSTRUKTUR_SUCCESS, newModule)
            } catch (error) {
                commit(SAVE_MODULSTRUKTUR_ERROR, error)
                return null
            }
        }
    }
}
